import { AGGREGATE_RATING, ORGANIZATION_NAME, SITE_URL } from './constants';

type SeoFields = {
  metaTitle?: string | null;
  metaDescription?: string | null;
};

type AreaServed =
  | { '@type': 'City'; name: string }
  | { '@type': 'Country'; name: string };

type Offers = {
  priceCurrency: string;
  lowPrice: string | number;
  highPrice: string | number;
  unitText?: string;
};

type BuildServiceSchemaInput = {
  title: string;
  description?: string | null;
  seo?: SeoFields | null;
  /** Overrides default 'Melbourne' City; use for NDIS (national Australia). */
  areaServed?: AreaServed;
  /** Overrides the default `serviceType = title`. */
  serviceType?: string;
  /** Optional AggregateOffer pricing information. */
  offers?: Offers;
};

const DEFAULT_AREA_SERVED: AreaServed = { '@type': 'City', name: 'Melbourne' };

export function buildServiceSchema({
  title,
  description,
  seo,
  areaServed = DEFAULT_AREA_SERVED,
  serviceType,
  offers,
}: BuildServiceSchemaInput): Record<string, any> {
  const schema: Record<string, any> = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: seo?.metaTitle ?? title,
    description: seo?.metaDescription || description || '',
    provider: {
      '@type': 'SportsActivityLocation',
      name: ORGANIZATION_NAME,
      url: SITE_URL,
      telephone: '1800446464',
      priceRange: '$$',
      aggregateRating: {
        '@type': 'AggregateRating',
        ...AGGREGATE_RATING,
      },
    },
    areaServed,
    serviceType: serviceType ?? title,
  };

  if (offers) {
    schema.offers = { '@type': 'AggregateOffer', ...offers };
  }

  return schema;
}
